const paymentIcons = document.querySelectorAll('.product-info__payment-logo');
const paymentModal = document.querySelectorAll('.payment-modal');

// Payment icons
if (paymentIcons) {
  paymentIcons.forEach(btn => btn.addEventListener('click', () => openPaymentModal(btn)));
}

function openPaymentModal(btn) {
  if (!paymentModal.length) return;
  const paymentType = btn.getAttribute('data-payment-icon-type');
  const paymentTabs = document.querySelectorAll('.payment-modal__tab');

  // Click the tab that corresponds to the clicked icon
  paymentTabs.forEach(tab => {
    const tabPaymentType = tab.getAttribute('data-payment-icon-type');
    if (tabPaymentType === paymentType) tab.click();
  });

  // disbaled scrolling
  document.body.classList.add('is-scroll-disabled');

  // Show the payment modal
  paymentModal[0].classList.add('is-visible');
}

document.querySelectorAll('.payment-modal').forEach(container => {
  const close = container.querySelector('.payment-modal__close');
  const tabs = container.querySelectorAll('.payment-modal__tab');
  const contents = container.querySelectorAll('.payment-modal__content');

  if (!close || !tabs) return;

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      let tabIndex = tab.getAttribute('data-tab-index');

      // remove active class on all tabs
      tabs.forEach(tab => tab.classList.remove('is-active'));

      // add class active to click tab
      tab.classList.add('is-active');

      contents.forEach(content => {
        let contentIndex = content.getAttribute('data-tab-index');

        // remove visible classes on all contents
        content.classList.remove('is-visible');

        // if it matches the index of the click tabbed, add visible class
        if (tabIndex === contentIndex) content.classList.add('is-visible');
      });
    });
  });

  // Close Modal
  close.addEventListener('click', () => {
    container.classList.remove('is-visible');
    document.body.classList.remove('is-scroll-disabled');
  });
});